export const useCurrentLanguage = () => {
  const route = useRoute();
  const { locale } = useI18n();

  const currentLanguage = ref(locale.value);

  watchEffect(() => {
    if (route.query.lang === 'it') {
      currentLanguage.value = 'it';
    } else {
      currentLanguage.value = locale.value;
    }
  });

  return {
    currentLanguage,
  };
};
